var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg10C(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2666_6337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0571289 -0.202917H39.9319V39.7861H-0.0571289V-0.202917ZM1.3074 1.16161V38.4215H38.5673V1.16161H1.3074Z",
    fill: "#041E42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1389 39.7293V39.7861H0V-0.125004H39.9316V39.7293H24.1389ZM11.2749 12.6936V1.175H1.3V12.6936H11.2749ZM22.5805 1.175H12.864V12.6936H22.5805V1.175ZM22.5805 14.1218H12.864V25.6388H22.5805V14.1218ZM12.864 26.9404H22.5805V38.5856H12.864V26.9404ZM24.1389 38.4293H38.6316V30.104L24.1389 30.104V38.4293ZM38.6316 28.7475V20.4868H24.1389V28.7475H38.6316ZM38.6316 10.8568V19.1222H24.1389V10.8568L38.6316 10.8568ZM38.6316 9.505V1.175L24.1389 1.175V9.505L38.6316 9.505ZM11.2749 26.9404H1.3V38.5856H11.2749V26.9404ZM1.3 14.1218H11.2749V25.6388H1.3V14.1218Z",
    fill: "#041E42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2666_6337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10C);
export default __webpack_public_path__ + "static/media/10c.df0853559bd03448c426e112711ec662.svg";
export { ForwardRef as ReactComponent };